import ThreadsTable from "./ThreadsTable";

/**
 * Every discussion, across every client system.
 *
 * The cross-client view: the place to answer "where is document 51316?" without
 * knowing whose it is. Day-to-day work on one client happens in that client's
 * own Muhokamalar tab, which shows the same table with the client fixed.
 */
const ThreadsPage = () => <ThreadsTable />;

export default ThreadsPage;
